import { tss } from "tss-react/mui";

export const useBlogArticleContentSectionStyles = tss.withName("BlogArticleContentSection").create(({ theme }) => ({
    root: {
        padding: "48px 4% 80px",
    },
    container: {
        maxWidth: 760,
        margin: "0 auto",
    },
    backLink: {
        display: "block",
        color: theme.palette.text.secondary,
        textDecoration: "none",
        marginBottom: theme.spacing(3),
        fontSize: "0.85rem",
        "&:hover": { color: theme.palette.primary.main },
    },
    category: {
        display: "inline-block",
        fontSize: "0.75rem",
        fontWeight: 700,
        color: theme.palette.primary.main,
        textTransform: "uppercase" as const,
        letterSpacing: "0.06em",
        marginBottom: theme.spacing(1.5),
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    meta: {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(4),
    },
    imageWrapper: {
        width: "100%",
        aspectRatio: "16 / 9",
        overflow: "hidden",
        marginBottom: theme.spacing(5),
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover" as const,
    },
    content: {
        color: theme.palette.text.primary,
        lineHeight: 1.9,
        fontSize: "1.05rem",
        "& p": { marginBottom: theme.spacing(2.5) },
    },
    relatedProducts: {
        marginTop: theme.spacing(6),
        paddingTop: theme.spacing(5),
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    relatedProductsTitle: {
        marginBottom: theme.spacing(3),
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr 1fr",
        },
    },
}));
